import { render, staticRenderFns } from "./UklonjenaVozila.vue?vue&type=template&id=539a0530&"
import script from "./UklonjenaVozila.vue?vue&type=script&lang=js&"
export * from "./UklonjenaVozila.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports